<script setup lang="ts"></script>

<template>
    <div class="text-white hover:text-brand-100 transition-colors absolute w-[64px] h-[64px] right-0 top-0 bg-brown-100 cursor-pointer flex items-center justify-center group" @click="$emit('close')">
        <vue-svg type="heroicons/outline/x" class="group-hover:rotate-180 transition-transform transform"></vue-svg>
    </div>
</template>
